import { toast } from 'react-toastify';

// space image validation
export const isValidUpload = (previews) => {
    if (!previews || previews.length <= 0) {
        toast.error('Please upload atleast one image or video!');
        return false;
    }
    if (previews?.length > 10) {
        toast.error('You can upload atmost 10 items!');
        return false;
    }
    let videoCount = 0;
    for (const file of previews) {
        if (
            file?.type === 'image/gif' ||
            file?.type === 'image/png' ||
            file?.type === 'image/jpg' ||
            file?.type === 'image/jpeg' ||
            file?.type === 'image'
        ) {
            continue;
        } else {
            videoCount = videoCount + 1;
        }
    }

    if (videoCount > 1) {
        toast.error('You can upload atmost 1 video!');
        return false;
    }

    return true;
};

// export const isValidUpload = (previews, spaceMedia) => {
//   let imageCount = 0;
//   let videoCount = 0;
//   if (previews.length <= 0) {
//     toast.error('Please upload atleast one image or video');
//     return false;
//   }
//   if (previews.length > 11) {
//     // setSelectedImageVideoPreviews([]);
//     // return { error: true, errorMessage: 'You can select upto 11 items' };
//     toast.error('You can select upto 11 items');
//     return false;
//   }

//   // check if only preview image, then allow without file size or any other checks
//   if (!spaceMedia && previews.length > 0) {
//     console.log('Yes its validddddd...');
//     return true;
//   }

//   const totalSize = previews.reduce((acc, obj) => acc + obj.size, 0);
//   const totalSizeInMb = totalSize / 1024 ** 2;
//   if (totalSizeInMb >= 20) {
//     // setSelectedImageVideoPreviews([]);
//     toast.error('Maximum file size should not be more than 20mb');
//     // return { error: true, errorMessage: 'Maximum file size should not be more than 20mb' };
//     return false;
//   }
//   for (const file of previews) {
//     if (
//       file?.type === 'image/gif' ||
//       file?.type === 'image/png' ||
//       file?.type === 'image/jpg' ||
//       file?.type === 'image/jpeg'
//     ) {
//       imageCount++;
//     } else {
//       videoCount++;
//     }
//   }

//   if (imageCount > 10) {
//     // setSelectedImageVideoPreviews([]);
//     // return { error: true, errorMessage: 'You can select maximum of 10 images' };
//     toast.error('You can select maximum of 10 images');
//     return false;
//   }
//   if (videoCount > 1) {
//     // setSelectedImageVideoPreviews([]);
//     toast.error('You can select maximum of 1 video');
//     return false;
//   }

//   return true;
// };
